import React from 'react'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'

import lang from '@/lang'
import config from 'config'
import CompanyImagePng from 'assets/images/wiso_buhl_sign.png'

const { agbUrl, imprintUrl, privacyUrl } = config

export const SubmenuFooter = () => {
  const { isDemo } = useSelector(state => state.subscription.details)
  const classes = useStyles()

  return (
    <>
      {isDemo && (<div className={classes.isDemo}>{lang.footer.isDemo}</div>)}
      <a className={classes.usercentrics} onClick={() => UC_UI?.showSecondLayer()}>{lang.footer.cookies}</a>
      <a className={classes.impressum} href={imprintUrl} rel="noopener noreferrer" target="_blank">{lang.footer.impressum}</a>
      <div className={classes.agbAndPrivacyContainer}>
        <a className={classes.agb} href={agbUrl} rel="noopener noreferrer" target="_blank">{lang.footer.agb}</a>{' '}&{' '}
        <a className={classes.privacy} href={privacyUrl} rel="noopener noreferrer" target="_blank">{lang.footer.legal}</a>
      </div>
      <div className={classes.image}>
        <img src={CompanyImagePng} alt="" />
      </div>
    </>
  )
}

const useStyles = makeStyles(theme => ({
  isDemo: {
    marginBottom: 20,
    color: theme.white,
    fontSize: theme.fontSizes.medium,
    fontWeight: theme.fontWeights.medium,
    fontStyle: 'italic',
  },
  item: {
    color: [[theme.navSubmenuImprintItemColorLight], '!important'],
    '&:hover': {
      color: [[theme.navSubmenuItemColorActive], '!important'],
    },
  },
  agbAndPrivacyContainer: {
    color: theme.navSubmenuImprintItemColorLight,
    display: 'flex',
  },
  usercentrics: {
    composes: '$item',
    marginBottom: 5,
  },
  impressum: {
    composes: '$item',
    marginBottom: 5,
  },
  agb: {
    composes: '$item',
    marginRight: 5,
  },
  privacy: {
    composes: '$item',
    marginLeft: 5,
  },
  image: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 12,
    '& img': {
      width: 120,
    },
  },
  and: {
    color: [[theme.navSubmenuImprintItemColorLight], '!important'],
    cursor: 'default',
  },
}))
